import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import Logo from '../../../images/logo-rakuna.svg';
import i18n from '../../../helpers/I18nJs';

const styles = theme => ({
  logoTitle: {
    display: 'block',
    maxWidth: '25%',
    height: 'auto',
    margin: 'auto',
    marginBottom: '5px',
    '@media (max-width: 1024px) and (min-height: 1024px)': {
      maxWidth: '50%',
      marginBottom: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '45%',
      marginBottom: '10px',
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: '10px',
    },
  },
  itemTitle: {
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      marginBottom: '20px',
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: '5px',
    },
    [theme.breakpoints.down('md')]: {
      fontWeight: '400',
      fontSize: '18px',
    },
  },
  personalRegistration: {
    [theme.breakpoints.down('md')]: {
      marginBottom: '10px',
    },
  },
  organizationRegistration: {
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: '10px',
    },
  },
  waitingApproval: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
    '@media (min-width: 1025px) and (max-width: 1300px)': {
      marginBottom: theme.spacing(1),
    },
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: '10px',
    },
  },
});

const callActions = {
  personalRegistration: {
    text: i18n.t('js.sign_up.header.personal_registration'),
    classCss: 'personalRegistration',
  },
  organizationRegistration: {
    text: i18n.t('js.sign_up.header.organization_registration'),
    classCss: 'organizationRegistration',
  },
  waitingApproval: {
    text: i18n.t('js.sign_up.header.waiting_approval'),
    classCss: 'waitingApproval',
  },
};

const HeaderForm = (props) => {
  const { classes, linkType } = props;
  const action = callActions[linkType] || { text: '', classCss: '' };

  return (
    <React.Fragment>
      <Logo className={classes.logoTitle} />
      <Typography
        component="h1"
        variant="h5"
        align="center"
        className={
          classNames({
            [classes[action.classCss]]: true, [classes.itemTitle]: true,
          })
        }
      >
        {action.text}
      </Typography>
    </React.Fragment>
  );
};

HeaderForm.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  linkType: PropTypes.string,
};

HeaderForm.defaultProps = {
  linkType: '',
};

export default withStyles(styles)(HeaderForm);
